// external
import { useNavigate } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

// components
import ProgressTracker from "components/ProgressTracker";
import FaoBuilderHeader from "../fao-layout/fao-builder-header";
import StepNavigation from "components/StepNavigation";
import RegimeNewColumn from "./regime-new-column";
import Loader from "components/partials/loader/loader";
import RegimeViewer from "./regime-viewer";
import FaoRegimeValidation from "./fao-regime-validation";

// state managing/security
import { FaoRegimeContext } from "context/FaoRegimeContext";
import { FaoBuilderContext } from "context/FaoBuilderContext";

// api
import apiRoot from "api/apiRoot";

// helpers
import { validateRegime } from "../helpers/regime-helpers";

// assets
import Icons from "assets/icons";
/*
TODO: 
  - clean up this component --> possibly break into smaller pieces
  - make sure custom components are being used
  - make column options some stored file instead of the current json so the changes to these column options persist
  - grab regime parameters from previous step - DONE
  - post regime config to cosmosdb - DONE
  - styling for the table needs to better in terms of the individual cells - shrink grow if there are more inputs
  - clean up code
  - height of the matrix population input looks weird
*/
function FaoRegimeConfig() {
  const {
    matrices,
    setMatrices,
    setDimensionsX,
    setDimensionsY,
    cellMetrics,
    setCellMetrics,
    columnOptions,
    setColumnOptions,
    setSelectedX,
    setSelectedY,
    currentlyEditing,
    fetchValidateDate,
  } = useContext(FaoRegimeContext);
  const [isSaved, setIsSaved] = useState(false);
  const { modelConfig, updateModelConfig } = useContext(FaoBuilderContext);

  const [validatePopup, setValidatePopup] = useState(false);
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsSaved(false);
  }, [matrices]);
  useEffect(() => {
    fetchRegimeParameters();
    fetchValidateDate();
  }, []);

  const fetchRegimeParameters = async () => {
    setIsLoading(true);
    const toastMessages = {
      pending: `Fetching Regime Parameters`,
      success: `SUCCESS - Regime Parameters Found`,
      error: "FAILED - Please Reach out to Support for Assistance",
    };
    const existingRegimeId = modelConfig.configs["regimeParams"];

    const promise = apiRoot.get(
      `/api/fao-regime/regimeparameters/${existingRegimeId}`
    );
    const res = await toast.promise(promise, toastMessages);
    setDimensionsX(res.data.xDimensions);
    setDimensionsY(res.data.yDimensions);
    // only grab the cell metrics that are true
    setCellMetrics(
      Object.fromEntries(
        Object.entries(res.data.cellMetrics).filter(([_, value]) => value)
      )
    );
    setSelectedX(res.data.xAxis);
    setSelectedY(res.data.yAxis);
    if (res.data.matrices != null && res.data.matrices.length > 0) {
      setMatrices(res.data.matrices);
    } else {
      const dimensions_array = new Array(res.data.yDimensions.length)
        .fill()
        .map(() => Array(res.data.xDimensions.length).fill(null));
      var baseMatrix = {
        name: "",
        logic: [
          {
            schema: "",
            table: "",
            column: "",
            operation: "=",
            value: [],
          },
        ],
      };
      Object.entries(res.data.cellMetrics).forEach(([key, value]) => {
        if (value) {
          baseMatrix[key] = dimensions_array;
        }
      });
      setMatrices([baseMatrix]);
    }
    setIsLoading(false);
  };

  const handleAddColumn = () => {
    setPopupOpen(true);
  };

  const postRegime = async () => {
    const valid = validateRegime(matrices);
    if (!valid) {
      toast.error("Please fill in all fields before saving");
      return;
    }
    setIsSaving(true);
    try {
      const toastMessages = {
        pending: "Saving FAO Regime Config",
        success: "SUCCESS - FAO Config Saved",
        error: "Regime not saved",
      };
      const existingRegimeId = modelConfig.configs["regimeParams"];
      const importData = {
        matrices: matrices,
      };
      const promise = apiRoot.post(
        `/api/fao-regime/add-regime-config/${existingRegimeId}`,
        importData
      );
      await toast.promise(promise, toastMessages);
      if (
        !modelConfig.configs["regimeConfig"] ||
        modelConfig.configs["regimeConfig"] === ""
      ) {
        await updateModelConfig("regimeConfig", existingRegimeId);
      }
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
    setIsSaved(true);
  };

  const onNextStep = () => {
    setValidatePopup(true);
  };
  const ListMatrices = () => {
    return (
      <div>
        <div className="mt-1 flex">
          <Icons.Info customClass="h-4 w-4 text-gray-500 mr-1 mt-1" />
          <p className="text-gray-500">Create regimes in order of priority</p>
        </div>
        {matrices.map((matrix, index) => {
          return (
            <RegimeViewer
              matrix={matrix}
              ind={index}
              isEditable={currentlyEditing === index}
              isDisplay={false}
              cellMetrics={cellMetrics}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div>
      <ToastContainer />
      <FaoBuilderHeader
        modelName={modelConfig.versionName}
        modelId={modelConfig.id}
      />
      <ProgressTracker />
      {popupOpen && (
        <RegimeNewColumn
          heading="Add a new column"
          setPopupOpen={setPopupOpen}
          allowedColumns={columnOptions}
          setAllowedColumns={setColumnOptions}
        />
      )}
      {isLoading ? <Loader /> : ListMatrices()}
      {validatePopup && (
        <FaoRegimeValidation setIsPopupOpen={setValidatePopup} />
      )}
      <StepNavigation
        onClickBack={() =>
          navigate(`../fao-builder/${modelConfig.id}/regime-param`)
        }
        isSaving={isSaving}
        disabledNext={!isSaved}
        onClickSave={postRegime}
        isSaved={isSaved}
        onClickNext={onNextStep}
      ></StepNavigation>
    </div>
  );
}

export default FaoRegimeConfig;
